import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import {
  Container,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody
} from 'reactstrap';
import { connect } from 'react-redux';
import { IAuthReduxProps, IPartsPercents, ITarget } from '../../types/interfaces';

import TableContainer from "../tables_manager/TableContainer"
import EditableCell from "../tables_manager/EditableCell";
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { getUsers } from '../../flux/actions/userActions';
import { editVenteCharge } from '../../flux/actions/venteActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faEye, faPen, faPlus, faSpinner, faSquare, faTimes } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import PartsPercentsGraphic from './PartsPercentsGraphic';

const PartsPercents = ({
  modal,
  setModal,
  modalVente,
  auth
 }: IPartsPercents) => {
  const alert = useAlert();

  const [idValue, setIdValue] = useState(-1);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [reEnable, setReEnable] = useState(false);
  
  const handleToggle = () => setModal(!modal);

  const modalOpenedHandle = () => {
    if(modalVente && modalVente !== ''){
      // setIdValue(modalVente["id"]);
      // setIsAssociation(!!modalVente["isAssLine"]);
      // setUserValue(userOptions.find(e => e.value?.id === Number(modalVente["charge_bien_id"] || 0))?.value || '');
    }
  };

  const modalClosedHandle = () => {
    setIdValue(-1);
    if(reEnable){
      setDisableSubmit(false);
      setReEnable(false);
    }
  };

  return (
    <div>
      <Modal isOpen={modal} toggle={handleToggle} onOpened={modalOpenedHandle} onClosed={modalClosedHandle}>
        <ModalHeader toggle={handleToggle}><FontAwesomeIcon icon={faEye} />&nbsp;&nbsp;Total des Pourcentages</ModalHeader>
        <ModalBody>
            <Container className="linesConfirmationContainer">
              <Row>
                {!!modalVente && <PartsPercentsGraphic associations={modalVente.associations} etages={modalVente.bien?.ETAGE_ASS} />}
                {/* {!!modalVente && <Col xs="12" className="mapTooltipField text-center fullFlexCenter" style={{wordBreak: "break-word", overflow: "hidden"}}>
                  {[
                    {floorName: "RDC", percent: modalVente.associations?.filter(e => e.ETAGE === "0").reduce((e, t) => t.POURCENTAGE ? e + t.POURCENTAGE : e, 0) || 0},
                    {floorName: "1", percent: modalVente.associations?.filter(e => e.ETAGE === "1").reduce((e, t) => t.POURCENTAGE ? e + t.POURCENTAGE : e, 0) || 0},
                    ...(Number(modalVente.bien?.ETAGE_ASS) >= 3 ? [{floorName: "2", percent: modalVente.associations?.filter(e => e.ETAGE === "2").reduce((e, t) => t.POURCENTAGE ? e + t.POURCENTAGE : e, 0) || 0}] : []),
                    ...(Number(modalVente.bien?.ETAGE_ASS) >= 4 ? [{floorName: "3", percent: modalVente.associations?.filter(e => e.ETAGE === "3").reduce((e, t) => t.POURCENTAGE ? e + t.POURCENTAGE : e, 0) || 0}] : []),
                    ...(Number(modalVente.bien?.ETAGE_ASS) >= 5 ? [{floorName: "4", percent: modalVente.associations?.filter(e => e.ETAGE === "4").reduce((e, t) => t.POURCENTAGE ? e + t.POURCENTAGE : e, 0) || 0}] : []),
                  ].map((e, key) => <div className="mapAssociationContainer" key={key}>
                    <div className="mapAssociationFloor">{e.floorName}</div>
                    <div className="mapAssociationBox"><div className="mapAssociationLoaded" style={{height: e.percent + "%"}}></div><div className="mapAssociationPercentText">{e.percent}%</div></div>
                  </div>)}
                </Col>} */}
              </Row>
            </Container>
        </ModalBody>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, { })(PartsPercents);
